import React from "react";
import Navbar from "../components/common/Navbar";
import "../styles/privacypolicy.css";

const Privacypolicy = () => {
  return (
    <>
      <Navbar />
      <div className="policy-page">
        <header className="policy-hero">
          <p className="policy-kicker">Legal</p>
          <h1 className="policy-title">Privacy Policy</h1>
          <p className="policy-updated">Last updated: September 2025</p>
        </header>

        <main className="policy-body">
          <p>
            Welcome to HKI Media, accessible from{" "}
            <a href="https://www.hkimedia.com/" target="_blank" rel="noreferrer">
              https://www.hkimedia.com/
            </a>
            . This page outlines our policies regarding the collection, usage, and
            disclosure of personal data when you interact with our website, and the
            options available to you regarding that data.
          </p>
          <p>
            By utilizing our services, you consent to the collection and utilization
            of information as outlined in this policy.
          </p>

          <h2>Information Collection and Usage</h2>
          <p>
            At HKI Media, we gather various types of information for diverse purposes
            to enhance and personalize your experience with our services.
          </p>

          <h3>Personal Information</h3>
          <p>
            During your website interactions, we may request specific personally
            identifiable information to facilitate communication or identification.
            This may encompass, but is not restricted to:
          </p>
          <ul>
            <li>Email address</li>
            <li>First and last name</li>
            <li>Address, city, state, province, ZIP/postal code</li>
            <li>Phone number</li>
            <li>Cookies and usage data</li>
          </ul>

          <h3>Usage Data</h3>
          <p>
            Additionally, we may collect data regarding how our website is accessed
            and utilized. This can include information such as your device&rsquo;s IP
            address, browser type, pages visited, duration of visit, and other
            diagnostic data.
          </p>

          <h3>Cookies Data</h3>
          <p>
            We employ cookies to enhance and optimize our service delivery. You retain
            the option to accept or decline these cookies, with notification provided
            when a cookie is being transmitted to your device. Refusing cookies may
            restrict certain functionalities of our service.
          </p>

          <h2>Data Utilization</h2>
          <p>HKI Media utilizes collected data for various purposes:</p>
          <ul>
            <li>Maintaining and improving our website</li>
            <li>Notifying users about website modifications</li>
            <li>Enabling participation in interactive website features</li>
            <li>Providing assistance and support</li>
            <li>Monitoring website usage</li>
            <li>Identifying and addressing technical issues</li>
          </ul>

          <h2>Retention of Your Personal Data</h2>
          <p>
            HKI Media retains your personal data only for the duration necessary to
            fulfill the purposes outlined in this Privacy Policy. We adhere to legal
            obligations and may retain data to comply with applicable laws, resolve
            disputes, and enforce agreements.
          </p>

          <h2>Transfer of Your Personal Data</h2>
          <p>
            Your information, including personal data, may be processed and maintained
            at HKI Media&rsquo;s operational sites. This could involve transferring
            information to locations outside your jurisdiction, where data protection
            laws may differ. By consenting to this Privacy Policy and submitting
            information, you agree to such transfers.
          </p>
          <p>
            HKI Media employs necessary measures to ensure the security and compliance
            of your data during transfer.
          </p>

          <h2>Delete Your Personal Data</h2>
          <p>
            You possess the right to request the deletion of personal data collected by
            HKI Media. Our service facilitates the deletion of specific information via
            account settings. Additionally, you may contact us for access to,
            correction, or deletion of your personal information.
          </p>
          <p>
            Please note, HKI Media may retain certain information as required by law or
            legal obligations.
          </p>

          <h2>Disclosure of Your Personal Data</h2>
          <p>Under specific circumstances, HKI Media may disclose your personal data:</p>
          <ul>
            <li>In the event of a business transaction, merger, or acquisition</li>
            <li>
              To comply with legal obligations or requests from public authorities
            </li>
            <li>To protect and defend HKI Media&rsquo;s rights and interests</li>
          </ul>

          <h2>Security of Your Personal Data</h2>
          <p>
            HKI Media employs commercially acceptable means to safeguard your personal
            data. However, no method of transmission or electronic storage is entirely
            secure. While we strive to protect your data, we cannot guarantee absolute
            security.
          </p>

          <h2>Children&rsquo;s Privacy</h2>
          <p>
            HKI Media&rsquo;s services are not directed toward individuals under the age
            of 13. We do not knowingly collect personally identifiable information from
            minors. If you are a parent or guardian and believe your child has provided
            us with personal data, please contact us for rectification.
          </p>

          <h2>Links to External Websites</h2>
          <p>
            Our service may contain links to external websites not operated by HKI
            Media. We advise reviewing the privacy policies of these third-party sites,
            as we hold no responsibility for their content or practices.
          </p>

          <h2>Policy Modifications</h2>
          <p>
            HKI Media may periodically update this Privacy Policy. We will notify you of
            any changes by posting the revised policy on our website. It is advised to
            review this policy periodically for updates.
          </p>

          <h2>Contact Us</h2>
          <p>
            For inquiries regarding this Privacy Policy, please contact us by email:{" "}
            <a href="mailto:events@hkimedia.in">events@hkimedia.in</a>
          </p>
        </main>
      </div>
    </>
  );
};

export default Privacypolicy;
